<template>
    <div class="flex border-t border-b -mb-px border-gray-200 bg-white">
        <div class="flex-1 p-0 -ml-px" :class="readOnly?'truncate':''">
            <page-cell
                :read-only="readOnly"
                class="text-gray-500 -mt-px px-2 mb-0 py-1 border-r border-l border-gray-200 hover:z-30 focus:z-40"
                :class="readOnly?'truncate':''"
                placeholder="..."
                v-model="name"
                @change="$emit('change',item.name,name)"
            ></page-cell>
        </div>
        <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right"
             v-text="toCurrency(item.materials)"></div>
        <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right" v-text="toCurrency(item.labour)"></div>
        <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right"
             v-text="toCurrency(item.fixedCosts)"></div>
    </div>
</template>

<script>
import * as math from "mathjs";
import {toCurrency} from "../../../../utils";
import UiInput from "../../../ui/UiInput.vue";
import PageCell from "../../../ui/PageCell.vue";

export default {
    components: {PageCell, UiInput},
    props: {
        item: Object,
        readOnly: false,
    },
    data() {
        return {
            math,
            name: '' + this.item.name,
        }
    },
    computed: {},
    methods: {toCurrency},
    mounted() {
    }
}
</script>
